import { SchemaColumnOptions, SchemaTableOptions } from "@/vendors/prx-sqlite/Interfaces/SchemaInterfaces";

export const risk_codes:SchemaTableOptions = {
    name:<string> 'risk_codes',
    schema:<Array<SchemaColumnOptions>> [
        { column: 'id', value: 'INTEGER PRIMARY KEY AUTOINCREMENT'},
        { column: 'description', value: 'VARCHAR(255) NOT NULL'},
    ]
}